import React, {createContext, useContext, useReducer} from "react";
import {AutoRetrieverDeviceOverviewReducer} from "../reducer/AutoRetrieverDeviceOverviewReducer";
import {PermissionsContext} from "../../../permissions/PermissionsContext";
import PermissionAlertBanner from "../../../commonui/PermissionAlertBanner";

export const AutoRetrieverDeviceOverviewContext = createContext();

const AutoRetrieverDeviceOverviewContextProvider = (props) => {
    const data = {
        sortPref: {column: "name", direction: "ascending"},
        autoRetrieverDeviceInformation: {},
        macAddressArray: [],
        testConfig: {},
        loadingOverview: true
    }
    const [viewModel, dispatch] = useReducer(AutoRetrieverDeviceOverviewReducer, data)
    const {isAuthorised} = useContext(PermissionsContext);

    if (!isAuthorised){
        return (
            <PermissionAlertBanner/>
        );
    }
    return (
        <AutoRetrieverDeviceOverviewContext.Provider value={{viewModel, dispatch}}>
            {props.children}
        </AutoRetrieverDeviceOverviewContext.Provider>
    )
}

export default AutoRetrieverDeviceOverviewContextProvider


// WEBPACK FOOTER //
// ./src/components/devicemanagement/autoretriever/context/AutoRetrieverDeviceOverviewContext.js